import "./footer.scss";

import React, { Fragment, useState } from "react";
import { findRel, findTarget } from "../../../shared/utils/stringUtilities";
import { graphql, useStaticQuery } from "gatsby";

import Follows from "../follows/follows";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FOOTER_CONTENT {
      allContentfulHome(filter: { titulo: { eq: "Home Home nutricion saludable" } }) {
        nodes {
          textCentralLlamadas
          redireccionTitulo
        }
      }
      allContentfulFooter(filter: { titulo: { eq: "Footer nutricion saludable" } }) {
        nodes {
          titulo
          categorias {
            nombreCategoria
            noVisibleFooter
            referenciaSubcategorias {
              titulo
              slug
              link
              nombreSubcategoria
              tipoCampo
            }
          }
        }
      }
      allContentfulMenuLoggin(
        filter: { titulo: { eq: "Menu login nutricion saludable" } }
      ) {
        nodes {
          logoGray {
            title
            file {
              url
            }
          }
        }
      }
      allContentfulFooterSeccion2(
        filter: { titulo: { eq: "Footer nutricion saludable" } }
      ) {
        nodes {
          descripcion {
            raw
          }
          lgoVigiladosVertical {
            title
            file {
              url
            }
          }
          logoAsojacas {
            title
            file {
              url
            }
          }
          logoVigiladosHorizontal {
            title
            file {
              url
            }
          }
        }
      }
    }
  `);

  interface StoreInterface {
    link?: string;
    title: string;
    file: {
      url: string;
    };
  }

  interface FooterInterface {
    nombreCategoria: string;
    noVisibleFooter: boolean;
    referenciaSubcategorias: {
      titulo: string;
      link: string;
      slug: string;
      nombreSubcategoria: string;
      tipoCampo: string;
    }[];
  }

  interface Footer2Interface {
    tituloPrincipal: string;
    descripcion: {
      raw: any;
    };
    lgoVigiladosVertical: StoreInterface;
    logoVigiladosHorizontal: StoreInterface;
    logoAsojacas: StoreInterface;
  }
  const queryFooter: FooterInterface[] =
    data?.allContentfulFooter?.nodes?.[0]?.categorias;
  const queryFooter2: Footer2Interface =
    data?.allContentfulFooterSeccion2?.nodes?.[0];
  const logoGray = data?.allContentfulMenuLoggin?.nodes?.[0]?.logoGray;
  const [selectIndex, setSelectIndex] = useState(-1);

  const toggleButton = (index: number) => {
    setSelectIndex(selectIndex === index ? -1 : index);
  };

  const hasRaw = queryFooter2?.descripcion?.raw;

  const hasQueryFooterData = hasRaw ? JSON.parse(hasRaw) : false;

  const getCallCenterItems = (items: FooterInterface[], classP: string) => {
    return (
      <div
        className={`f-container__one ${classP} f-container__call call_center`}
        key={1}
      >
        {items?.map((val, key) =>
          !val.noVisibleFooter ? (
            <Fragment key={key}>
              <span
                className={`f-container__one__title f-container__one__title__first show-on-mobile `}
                onClick={() => toggleButton(key)}
              >
                {val?.nombreCategoria}
              </span>
              <ul className="f-container__one__list one__list__padding">
                {val?.referenciaSubcategorias?.map((subVal, key2) => (
                  <li className="f-container__one__list__li" key={key2}>
                    <span className={`f-container__one__title title_sub`}>
                      {subVal?.titulo}
                    </span>
                    <a
                      rel="nofollow noreferrer"
                      className="mobile-color"
                      title={subVal?.nombreSubcategoria}
                      href={`tel:${
                        subVal?.titulo ===
                        "Nuestro horario de orientación psicológica es de:"
                          ? ""
                          : subVal?.nombreSubcategoria
                      }`}
                    >
                      <i
                        className={`${
                          subVal?.titulo ===
                          "Nuestro horario de orientación psicológica es de:"
                            ? ""
                            : "icon-phone show-on-mobile"
                        }`}
                      />
                      {subVal?.nombreSubcategoria}
                    </a>
                  </li>
                ))}
              </ul>
            </Fragment>
          ) : (
            <></>
          )
        )}
      </div>
    );
  };
  let aux = 1;
  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };
  const getNormalItems = (items) =>
    items?.map((val: FooterInterface, key: number) =>
      !val.noVisibleFooter ? (
        <div className={`f-container__one footer${key}`} key={key}>
          <span
            className={`f-container__one__title f-container__one__title__first mode-mobile ${
              key === selectIndex ? "mode-mobile__show" : ""
            }`}
            onClick={() => toggleButton(key)}
          >
            {val.nombreCategoria}
          </span>
          <ul className="f-container__one__list">
            {val?.referenciaSubcategorias?.map((subVal, key2) => {
              //const gtm = `gtm${normalizeTwoWords(
              //  val.nombreCategoria
              //)}${normalizeTwoWords(subVal.nombreSubcategoria)}`;
              //console.log(subVal.slug);
              let ref;
              if (isHttp(subVal?.slug)) {
                ref = subVal?.slug;
              } else {
                //ref = (subVal.slug && `/${subVal.slug}`) || subVal.link;
                ref = (subVal?.slug && `/${subVal.slug}`) || subVal.link;
              }

              if (val?.nombreCategoria === "Te escuchamos") {
                if (aux === 1) {
                  aux = aux + 1;
                  return getCallCenterItems(queryFooter?.slice(0, 1), "call");
                }
              } else {
                return (
                  <li className={`f-container__one__list__li `} key={key2}>
                    <a
                      title={subVal?.nombreSubcategoria}
                      href={ref}
                      target={findTarget(ref)}
                      rel={findRel(ref)}
                    >
                      {subVal?.nombreSubcategoria}
                    </a>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      ) : (
        <></>
      )
    );

  return (
    <footer className="m-footer">
      <div className="f-container">
        {getNormalItems(queryFooter?.slice(0, 4))}
      </div>
      <div className="f-final-content">
        <div className="f-final-content__box hide-on-mobile">
          <article className="f-final-content__box__body">
            {hasQueryFooterData
              ? documentToReactComponents(hasQueryFooterData)
              : ""}
          </article>
        </div>
        <div
          className={`f-final-content__zone f-final-content__zone--super container`}
        >
          <div className="call">
            <img
              className="f-final-content__zone__logo show-on-mobile"
              src={logoGray?.file?.url}
              alt={logoGray?.title}
            />
            <div className="show-on-mobile colorCalls">
              {getCallCenterItems(queryFooter?.slice(0, 1), "call")}
            </div>
            <div className="f-final-content__followers">
              <Follows query={queryFooter?.[4]} />
            </div>
            <div className="show-on-mobile colorCalls last-item">
              <ul className="">
                <li className={`f-container__one__list__li `}>
                  <a
                    className={`f-container__one__list__li__link `}
                    title={"Terminos y condiciones"}
                    href={
                      "https://serviciosenlinea.comfama.com/webinicio/CondicionesDeUso.html"
                    }
                    target={findTarget(
                      "https://serviciosenlinea.comfama.com/webinicio/CondicionesDeUso.html"
                    )}
                    rel={findRel(
                      "https://serviciosenlinea.comfama.com/webinicio/CondicionesDeUso.html"
                    )}
                  >
                    {"Terminos y condiciones"}
                  </a>
                </li>
                <li className={`f-container__one__list__li `}>
                  <a
                    className={`f-container__one__list__li__link `}
                    title={"Politica de tratamiento de datos"}
                    href={
                      "https://serviciosenlinea.comfama.com/webinicio/HabeasData.htm"
                    }
                    target={findTarget(
                      "https://serviciosenlinea.comfama.com/webinicio/HabeasData.htm"
                    )}
                    rel={findRel(
                      "https://serviciosenlinea.comfama.com/webinicio/HabeasData.htm"
                    )}
                  >
                    {"Politica de tratamiento de datos"}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <div className="f-final-content__box show-on-mobile">
                <article className="f-final-content__box__body">
                  {hasQueryFooterData
                    ? documentToReactComponents(hasQueryFooterData)
                    : ""}
                </article>
              </div>
            </div>
            <div className="rotar-img show-on-mobile ">
              <div className="f-mobile__content">
                <img
                  src={queryFooter2?.logoVigiladosHorizontal?.file?.url}
                  alt={queryFooter2?.logoVigiladosHorizontal?.title}
                />
                <button
                  className="f-final-content__zone__final__button   icon-arrow-up "
                  onClick={() =>
                    scroll({
                      top: 0,
                      left: 0,
                      behavior: "smooth",
                    })
                  }
                />
              </div>
            </div>
            {/* TODO: it looks like in the xd is not need the next img */}
            <img
              className="f-final-content__zone__logo  hide-on-mobile"
              src={logoGray?.file?.url}
              alt={logoGray?.title}
            />
          </div>
          <div className="f-final-content__zone__final">
            <button
              className="f-final-content__zone__final__button icon-arrow-up hide-on-mobile"
              onClick={() =>
                scroll({
                  top: 0,
                  left: 0,
                  behavior: "smooth",
                })
              }
            />
            <img
              className="hide-on-mobile"
              src={queryFooter2?.lgoVigiladosVertical?.file?.url}
              alt={queryFooter2?.lgoVigiladosVertical?.title}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
